module.exports = __webpack_public_path__ + "img/SI5448557.3c22ee8e.jpeg";